<template>
<form @submit.prevent="submit" autocomplete="off">
    <ui-alert type="error" v-for="e,index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>

    <fieldset>
        <legend>Podstawowe dane</legend>

        <ui-textbox label="Twoja nazwa grupy" name="name" type="text" v-model="item.name" validation-rules="required" :validation-messages="errorMessages" placeholder="Wpisz nazwę"></ui-textbox>

        <i-select name="account" label="Konto do wysłania wiadomości przy zapisywaniu się do tej grupy" v-model="item.email_account_id" :options="accounts" placeholder="Wybierz konto" required></i-select>

        <i-select name="status" label="Status" v-model="item.status" :options="statuses" placeholder="Wybierz status" required></i-select>

        <ui-checkbox name="public" v-model="item.public">Grupa publiczna</ui-checkbox>

    </fieldset>

    <fieldset v-if="item.public">
        <legend>Formularz zapisywania się</legend>

        <ui-textbox label="Tytuł" name="form_title" type="text" v-model="item.form_title" placeholder="Wpisz tytuł formularza"></ui-textbox>

        <ui-textbox label="Tekst przycisku" name="form_submit_btn" type="text" v-model="item.form_submit_btn" placeholder="Wpisz tekst przycisku"></ui-textbox>

        <ui-textbox label="Dodatkowa treść nad formularzem" name="form_html_body" type="text" v-model="item.form_html_body" :multi-line="true" :rows="4" placeholder="Wpisz dodatkową treść"></ui-textbox>

        <ui-checkbox name="user_agree" v-model="item.user_agree">Wymagana zgoda (1)</ui-checkbox>
        <div v-if="item.user_agree">

            <ui-textbox label="Tekst zgody (1)" name="user_agree_text" type="text" v-model="item.user_agree_text" placeholder="Wpisz tekst zgody" :multi-line="true" :rows="2"></ui-textbox>

            <ui-textbox label="Link z dodatkowymi informacjami (1)" name="user_agree_url" type="text" v-model="item.user_agree_url" placeholder="Link z dodatkowymi informacjami"></ui-textbox>

            <ui-textbox label="Tekst linku z dodatkowymi informacjami (1)" name="user_agree_label" type="text" v-model="item.user_agree_label" placeholder="Tekst linku z dodatkowymi informacjami"></ui-textbox>

        </div>

        <ui-checkbox name="user_agree2" v-model="item.user_agree2">Wymagana zgoda (2)</ui-checkbox>
        <div v-if="item.user_agree2">

            <ui-textbox label="Tekst zgody (2)" name="user_agree2_text" type="text" v-model="item.user_agree2_text" placeholder="Wpisz tekst zgody" :multi-line="true" :rows="2"></ui-textbox>

            <ui-textbox label="Link z dodatkowymi informacjami (2)" name="user_agree2_url" type="text" v-model="item.user_agree2_url" placeholder="Link z dodatkowymi informacjami"></ui-textbox>

            <ui-textbox label="Tekst linku z dodatkowymi informacjami (2)" name="user_agree2_label" type="text" v-model="item.user_agree2_label" placeholder="Tekst linku z dodatkowymi informacjami"></ui-textbox>

        </div>

          <ui-textbox label="Tekst komunikatu po poprawnym zapisaniu się" name="success_msg" type="text" v-model="item.success_msg" placeholder="Tekst komunikatu po poprawnym zapisaniu się"></ui-textbox>

    </fieldset>
    <fieldset>
    <legend>E-mail z linkiem potwierdzającym</legend>

    <i-select name="success_signup_template_text" label="Szablon tekstowy" :keys="keysForTemplateSelect" v-model="item.success_signup_template_text" :options="templates_text" placeholder="Wybierz szablon"></i-select>

    <i-select name="success_signup_template_html" label="Szablon html" :keys="keysForTemplateSelect" v-model="item.success_signup_template_html" :options="templates_html" placeholder="Wybierz szablon"></i-select>

    <ui-textbox label="Dodatkowa treść" name="confirm_email_body" type="text" v-model="item.confirm_email_body" placeholder="Wpisz dodatkową treść" :multi-line="true" :rows="2"></ui-textbox>

    </fieldset>

    <fieldset>
    <legend>Strona potwierdzenia adresu e-mail</legend>


    <i-select name="confirm_page_template" label="Szablon html" :keys="keysForTemplateSelect" v-model="item.confirm_page_template" :options="templates_html" placeholder="Wybierz szablon"></i-select>


    </fieldset>

    <div class="form-actions">
        <ui-button color="primary">{{ item.id ? 'Aktualizuj' : 'Dodaj' }}</ui-button>
    </div>
</form>

</template>
<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'
import FormErrors from '../../mixins/FormErrors'
import Utils from '../../services/Utils'

import Templates from '../../services/Templates'
import EmailGroups from './../../services/EmailGroups'
import Accounts from './../../services/Accounts'

export default {
  mixins: [Loading, Notify, FormErrors],
  props: {
    item: {
      type: Object,
      default: EmailGroups.getBaseItem()
    }
  },
  data () {
    return {
      errors: [],
      title: 'Dodaj grupę',
      action: 'Dodaj grupę',
      statuses: EmailGroups.statuses(),
      accounts: [],
      keysForSelect: Utils.keysForSelect(),
      keysForTemplateSelect: {
        label: 'name',
        value: 'code'
      },
      templates_html: [],
      templates_text: [],
      errorMessages: Utils.errorMessages([
        'required',
        'min',
        'numeric',
        'email'
      ])
    }
  },
  mounted () {
    if (this.item.id) {
      this.title = 'Aktualizuj grupę'
      this.action = 'Aktualizuj grupę'
    }
    this.getAccounts()
    this.getTemplates()
  },
  methods: {
    resetForm () {
      this.item = EmailGroups.getBaseItem()
    },
    getAccounts () {
      this.setLoading(true)
      Accounts.names().then(res => {
        this.accounts = res.data.items

        this.setLoading(false)
      })
    },
    getTemplates () {
      this.setLoading(true)
      Templates.names().then(res => {
        this.templates_text = [{code: null, name: 'Domyślny szablon'}].concat(
          res.data.items.filter(item => item.template_type === 'text')
        )
        this.templates_html = [{code: null, name: 'Domyślny szablon'}].concat(
          res.data.items.filter(item => item.template_type === 'html')
        )
        this.setLoading(false)
      })
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy')
    },
    success (res) {
      if (this.item.id) {
        if (res.status === 200) {
          this.$emit('email-groups.update', this.item)
          this.notify('Zmieniłeś grupę')
          this.$router.push({
            name: 'admin.email-groups.show',
            params: {id: this.item.id}
          })
        }
      } else {
        if (res.status === 201) {
          this.$emit('email-groups.create', this.item)
          this.notify('Dodałeś grupę')
          this.$router.push({
            name: 'admin.email-groups.show',
            params: {id: res.data.item.id}
          })
        }
      }
    },
    submit () {
      this.errors = []
      window.scrollTo(0, 0)

      let item = {}
      if (this.item.id) {
        item.id = this.item.id
      }
      item.name = this.item.name
      item.status = this.item.status
      item.email_account_id = this.item.email_account_id
      item.public = this.item.public

      item.user_agree = this.item.user_agree
      item.user_agree_text = this.item.user_agree_text
      item.user_agree_url = this.item.user_agree_url
      item.user_agree_label = this.item.user_agree_label

      item.user_agree2 = this.item.user_agree2
      item.user_agree2_text = this.item.user_agree2_text
      item.user_agree2_url = this.item.user_agree2_url
      item.user_agree2_label = this.item.user_agree2_label

      item.form_title = this.item.form_title
      item.form_submit_btn = this.item.form_submit_btn
      item.form_html_body = this.item.form_html_body
      item.success_msg = this.item.success_msg
      item.success_signup_template_html = this.item.success_signup_template_html
      item.success_signup_template_text = this.item.success_signup_template_text
      item.confirm_page_template = this.item.confirm_page_template

      item.confirm_email_body = this.item.confirm_email_body
      if (this.item.id) {
        EmailGroups.update(item).then(this.success, this.error)
      } else {
        EmailGroups.create(item).then(this.success, this.error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?1dea366c